export default {"src":"/_next/static/media/droplet-own.08c4293b.svg","height":100,"width":100};